'use client';

import { c as _c } from "react/compiler-runtime";
import { useRenown } from '@powerhousedao/reactor-browser';
import { useEffect } from 'react';
import type { PowerhouseClient } from '../client/create-client';

/**
 * Bridges the React-tree-scoped Renown instance to a specific
 * {@link PowerhouseClient} by registering a bearer-token provider on it.
 * Internal to the SDK — apps should not mount this directly; use
 * `<PowerhouseSDKProvider>`.
 *
 * Token expiry is 600s; every reactor request mints a fresh one through the
 * provider, so rotation is automatic. We deliberately omit the `aud` claim —
 * the switchboard's verifier doesn't configure an expected audience and
 * did-jwt rejects tokens carrying `aud` without matching server config.
 */
export function RenownAuthBridge(t0) {
  const $ = _c(4);
  const {
    client
  } = t0;
  const renown = useRenown();
  let t1;
  let t2;
  if ($[0] !== client || $[1] !== renown) {
    t1 = () => {
      if (!renown) {
        client.setTokenProvider(null);
        return;
      }
      client.setTokenProvider(async () => {
        try {
          return await renown.getBearerToken({
            expiresIn: 600
          });
        } catch {
          return null;
        }
      });
      return () => {
        client.setTokenProvider(null);
      };
    };
    t2 = [renown, client];
    $[0] = client;
    $[1] = renown;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
}